import { FormProvider, useForm } from 'react-hook-form'
import dynamic from 'next/dynamic'

import { CartItemBalance, CartAdditionalCharges } from '@/components/cart'
import CartItemStyleProvider from '@/context/CartItemStyleContext'
import { useCartItem } from '@/context/CartItemContext'
import BuilderProvider from '@/context/BuilderContext'

// Dynamic import of CartItemStyleQuantity
const CartItemStyleQuantity = dynamic(
	() => import('@/components/cart').then((mod) => mod.CartItemStyleQuantity),
	{ ssr: false }
)

type Props = {
	readOnly?: boolean
}

export default function CartItemReview({ readOnly = false }: Props) {
	const { cartItem, addOnsWithTotalPrice, addOns } = useCartItem()
	const methods = useForm()

	return (
		<FormProvider {...methods}>
			<form className="row row--bottom">
				<ul className="card">
					{/* Item Styles review */}
					{cartItem?.itemStyles.map((itemStyle) => (
						<CartItemStyleProvider style={itemStyle} key={itemStyle.token}>
							<BuilderProvider>
								<CartItemStyleQuantity readOnly={readOnly} />
							</BuilderProvider>
						</CartItemStyleProvider>
					))}

					{/* Additional Charges */}
					{addOns?.length > 0 && addOnsWithTotalPrice?.length > 0 && (
						<li>
							<h3 className="card-head">Additional Charges</h3>
							<div className="w-full">
								{addOnsWithTotalPrice.map((addOn) => (
									<CartAdditionalCharges
										key={addOn.key + cartItem.token}
										addOns={addOn}
										readOnly={readOnly}
									/>
								))}
							</div>
						</li>
					)}

					{/* Balance*/}
					<CartItemBalance />
				</ul>
			</form>
		</FormProvider>
	)
}
